<template>
<div class="p-grid">
	<div class="profile-account p-col-6">
		<loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
		<Toast />

		<div class="profile-account-inner">
			<div class="profile-account-content" v-if="!personal.company">
				<h2>Personal data</h2>

				<div class="profile-account-body">
					<div class="form-item">
						<label for="client-id">Client ID</label>
						<InputText id="client-id" placeholder="Client ID" v-model="personal.id" disabled />
					</div>
					<div class="form-item">
						<label for="user-name">Username</label>
						<InputText id="user-name" placeholder="Username" v-model="personal.username" disabled />
					</div>
					<div class="form-item">
						<label for="first-name">First Name</label>
						<InputText id="first-name" placeholder="First Name" v-model="personal.first_name" disabled />
					</div>
					<div class="form-item">
						<label for="last-name">Last Name</label>
						<InputText id="last-name" placeholder="Last Name" v-model="personal.last_name" disabled />
					</div>
					<div class="form-item">
						<label for="email">Email</label>
						<InputText id="email" placeholder="Email" v-model="personal.email" />
					</div>
					<!--<div class="form-item">
						<label for="date-of-birth">Date of birth</label>
						<InputMask id="date-of-birth" placeholder="Date of birth (yyyy-mm-dd)" v-model="personal.date_of_birth" slotChar="yyyy-mm-dd" mask="9999-99-99" />
					</div>
					<div class="form-item">
						<label for="phone">Phone</label>
						<InputText id="phone" placeholder="Phone" v-model="personal.phone" />
					</div>
					<div class="form-item">
						<label for="address">Address</label>
						<InputText id="address" placeholder="Address" v-model="personal.address" />
					</div>
					<div class="form-item">
						<label for="zip-code">Zip code</label>
						<InputText id="zip-code" placeholder="Zip code" v-model="personal.zip" />
					</div>
					<div class="form-item">
						<label for="city">City</label>
						<InputText id="city" placeholder="City" v-model="personal.city" />
					</div>
					<div class="form-item">
						<label for="country">Country</label>
						<InputText id="country" placeholder="Country" v-model="personal.country" />
					</div>-->
					<div class="form-action">
						<Button @click="updateProfile()" label="Save Personal Data" />
					</div>
				</div>

				<div class="profile-account-refferal">
					<div class="form-item">
						<label for="refferal-link">Referral link</label>
						<InputText id="refferal-link" placeholder="Partner Referral link" v-model="partnerReferralLink" ref="myurl" disabled />
						<div class="form-action">
							<Button class="btn-copy-to-clipboard" label="" icon="icon icon-copy" @click="copyToClipboard(partnerReferralLink)"/>
						</div>
					</div>
					<!--<div class="form-item">
						<label for="refferal-link-customer">Customer Referral link</label>
						<InputText id="refferal-link-customer" placeholder="Customer Referral link" v-model="customerReferralLink" ref="myurl" disabled />
						<div class="form-action">
							<Button class="btn-copy-to-clipboard" label="" icon="icon icon-copy" @click="copyToClipboard(customerReferralLink)"/>
						</div>
					</div>-->

					<div class="form-action">
						<Button @click="inviteFriends()" label="Invite a friend" />
					</div>
				</div>

			</div>

			<!--<div class="profile-account-content" v-if="personal.company">
				<h2>Company data</h2>

				<div class="profile-account-body">
					<div class="form-item">
						<label for="phone">Phone</label>
						<InputText id="phone" placeholder="Phone" v-model="company.phone" />
					</div>
					<div class="form-item">
						<label for="address">Address</label>
						<InputText id="address" placeholder="Address" v-model="company.address" />
					</div>
					<div class="form-item">
						<label for="zip-code">Zip code</label>
						<InputText id="zip-code" placeholder="Zip code" v-model="company.zip" />
					</div>
					<div class="form-item">
						<label for="city">City</label>
						<InputText id="city" placeholder="City" v-model="company.city" />
					</div>
					<div class="form-item">
						<label for="country">Country</label>
						<InputText id="country" placeholder="Country" v-model="company.country" />
					</div>
					<div class="form-item">
						<label for="last-name">VAT</label>
						<InputText id="vat" placeholder="VAT" v-model="company.vat" />
					</div>
					<div class="form-item">
						<label for="last-name">Reg No</label>
						<InputText id="reg_no" placeholder="Reg No" v-model="company.reg_no" />
					</div>
					<div class="form-item">
						<label for="last-name">Homepage</label>
						<InputText id="homepage" placeholder="Homepage" v-model="company.homepage" />
					</div>
					<div class="form-item">
						<label for="last-name">Directors</label>
						<InputText id="directors" placeholder="Directors" v-model="company.directors" />
						<Button icon="pi pi-plus" class="p-button" />
					</div>
					<div class="form-item">
						<label for="last-name">Owners</label>
						<InputText id="owners" placeholder="Owners" v-model="company.owners" />
						<Button icon="pi pi-plus" class="p-button" />
					</div>
					<div class="form-action">
						<Button @click="updateCompany()" label="Update Company Account" />
					</div>
				</div>

				<div class="profile-account-refferal">
					<div class="form-item">
						<label for="refferal-link">Partner Referral link</label>
						<InputText id="refferal-link" placeholder="Partner Referral link" v-model="partnerReferralLink" ref="myurl" disabled />
						<div class="form-action">
							<Button class="btn-copy-to-clipboard" label="" icon="icon icon-copy" @click="copyToClipboard(partnerReferralLink)"/>
						</div>
					</div>
					<div class="form-item">
						<label for="refferal-link-customer">Customer Referral link</label>
						<InputText id="refferal-link-customer" placeholder="Customer Referral link" v-model="customerReferralLink" ref="myurl" disabled />
						<div class="form-action">
							<Button class="btn-copy-to-clipboard" label="" icon="icon icon-copy" @click="copyToClipboard(customerReferralLink)"/>
						</div>
					</div>

					<div class="form-action">
						<Button @click="inviteFriends()" label="Invite a friend" />
					</div>
				</div>

			</div>-->
		</div>
	</div>
	<div class="p-col-1"></div>
	<!--<div class="profile-account p-col-6" v-if="!personal.company">
		<div class="profile-account-inner">
			<div class="profile-account-content">
				<h2>Company data</h2>

				<div class="profile-account-body" v-if="!company.id">
					<div class="form-item">
						<label for="first-name">Company Name</label>
						<InputText id="first-name" placeholder="Company Name" v-model="company.name" />
					</div>
					<div class="form-item">
						<label for="email">Email</label>
						<InputText id="email" placeholder="Email" v-model="company.email" />
					</div>
					<div class="form-item">
						<label for="password">Password</label>
						<Password placeholder="Password" v-model="company.password" />
					</div>
					<div class="form-item">
						<label for="password-confirm">Confirm Password</label>
						<Password id="password-confirm" placeholder="Confirm Password" v-model="company.confirmpassword" />
					</div>
					<div class="form-action">
						<Button @click="createCompany()" label="Create Company Account" />
					</div>
				</div>-->

				<!--<div class="profile-account-body" >
					<h4>To activate your company account please validate your company email and log in to continue to edit your data</h4>
				</div>-->

			<!--</div>
		</div>
	</div>-->

	<Dialog header="Invite friends to join" :visible.sync="invite.dialog" :style="{width: '50vw'}" :modal="true">
		<div class="card card-w-title">
			<div class="form">
				<div class="form-item">
					<label for="emails">Emails: </label>
					<InputText id="emails" placeholder="Emails" v-model="invite.emails" />
				</div>
				<div class="form-item">
					<label for="msg">Message</label>
					<InputText id="msg" placeholder="Message" v-model="invite.msg" />
				</div>
			</div>
		</div>
		
		<template #footer>
			<div class="p-grid">
				<div class="p-md-6 p-offset-6">
					<Button @click="sendInvites()" label="Send invitations" style="word-break: break-all;" />
				</div>
			</div>
		</template>
	</Dialog>
</div>
</template>

<script>

import UserService from '../../service/UserService.js';
import RegisterService from "../../service/RegisterService.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
	data() {
		return {
			personal: {
				id:'',
				username: '',
				first_name: '',
				last_name: '',
				date_of_birth: '',
				email: '',
				phone: '',
				address: '',
				zip: '',
				city: '',
				company: '',
			},
			company: {
				id:'',
				username: '',
				first_name: '',
				last_name: '',
				date_of_birth: '',
				email: '',
				phone: '',
				address: '',
				zip: '',
				city: '',
				password: '',
				confirmpassword: '',
			},
			apiUrl: process.env.VUE_APP_AUTH_URL + 'api/v1/kyc',
			staticUrl: process.env.VUE_APP_AUTH_URL,
			referralLink: null, 
			name: null, 
			surname: null, 
			email: null,
			isLoading: false,
			invite: {
				emails: '',
				msg: '',
				link: '',
				dialog: false,
			},
		}
	},
	components: {
		Loading
	},
	created() {
		this.$store.commit('setPageTitle', {pageTitle: 'Account'});
		this.userService = new UserService()
		this.registerService = new RegisterService();
		this.partnerReferralLink = process.env.VUE_APP_FRONT_URL + '#/partner?id=' + this.$store.state.currentUser.id
		this.customerReferralLink = process.env.VUE_APP_FRONT_URL + '#/customer?id=' + this.$store.state.currentUser.id
		this.invite.link = this.partnerReferralLink
		this.surname = this.$store.state.currentUser.surname || ''
		this.name = this.$store.state.currentUser.name || ''
		this.email = this.$store.state.currentUser.email || ''
		
        this.personal = {
            id: this.$store.state.currentUser.id,
			username: this.$store.state.currentUser.username,
			first_name: this.$store.state.currentUser.first_name,
			last_name: this.$store.state.currentUser.last_name,
			date_of_birth: this.$store.state.currentUser.date_of_birth,
			email: this.$store.state.currentUser.email,
			phone: this.$store.state.currentUser.phone,
			address: this.$store.state.currentUser.address,
			zip: this.$store.state.currentUser.zip,
			city: this.$store.state.currentUser.city,
			country: this.$store.state.currentUser.country,
			company: this.$store.state.currentUser.company
		}

		this.company = {
			id: this.$store.state.currentUser.company_id,
			username: this.$store.state.currentUser.username,
			email: this.$store.state.currentUser.email,
			phone: this.$store.state.currentUser.phone,
			address: this.$store.state.currentUser.address,
			zip: this.$store.state.currentUser.zip,
			city: this.$store.state.currentUser.city,
			country: this.$store.state.currentUser.country,
		}
		console.log(this.personal);
		
		// this.company.id = 1
	},
	mounted() {
		// if (this.$store.state.currentUser.btc_wallet == null) {
		// 	this.$store.commit('openDialog', {
		// 		header: 'Missing banking data!',
		// 		body: 'Enter your banking data before continuing'
		// 	})
		// }
		
		
	},
	methods: {
		async updateProfile() {
			this.isLoading = true
			await new Promise(r => setTimeout(r, 2000));
			this.userService.updateUser(this.personal)
			this.$store.commit('updatePersonalData', this.personal)
			this.isLoading = false
			this.$toast.add({ severity: 'success', summary: 'Personal data saved!', life: 3000 });
		},

		async createCompany() {
			const resp = await this.registerService.registerCompany({
				name: 'Company:',
				surname: this.company.name,
				username: this.company.name,
				company_name: this.company.name,
				email: this.company.email,
				password: this.company.password,
				company: true,
				refid: this.$store.state.currentUser.id,
			});
			console.log('status')
			console.log(resp);
			if (resp.status == 400) {
				this.$store.commit('setErrorDialogMsg', resp.data.message);
				this.$store.commit('openErrorDialog');
			}
			if (resp.status == 200) {
				this.$toast.add({
					severity: "success",
					summary: "Registration success!",
					detail: "redirect to login",
					life: 3000,
					position: "topleft"
				});

				var self = this;
				setTimeout(function () {
					self.$router.push({
						name: "login"
					});
				}, 2000);
			}
		},

		async updateCompany() {
			this.isLoading = true
			await new Promise(r => setTimeout(r, 2000));
			this.userService.updateCompany(this.company)
			this.isLoading = false
			this.$toast.add({ severity: 'error', summary: 'Please wait, not finished yet!', life: 3000 });
		},

		async copyToClipboard(link) {
			await navigator.clipboard.writeText(link);
			this.$toast.add({ severity: 'success', summary: 'Referral link copied to clipboard!', life: 3000 });
		},

		inviteFriends() {
			this.invite.dialog = true
		},

		async sendInvites() {
			this.isLoading = true
			this.invite.dialog = false
			await new Promise(r => setTimeout(r, 2000));
			await this.userService.inviteFriends(this.invite)
			this.isLoading = false
			this.$toast.add({ severity: 'success', summary: 'Invitations sent!', life: 3000 });
		}
	}
}

</script>

<style scoped>

</style>